import { Interval } from 'luxon';

import { EntityType } from 'common/types';

import { PerformanceByVenueInsight } from './types';
import merchantGatewayApi from '../../api';
import { getBaseUrl, getBaseUrlV2, getDateRangeForApiCall } from '../utils';

export const getPerformanceByVenueInsightForEntity = ({
  entityType,
  entityId,
  interval,
  limit,
  cursor,
  sortBy,
  sortOrder,
  locale,
  v2,
}: {
  entityType: Exclude<EntityType, 'venue'>;
  entityId: string;
  interval: Interval;
  /** default value 10 → max value 100 */
  limit?: number;
  cursor?: string;
  /**  Accepted values: SALES_WITH_VAT, ORDERS  AVG_BASKET_SIZE_ITEMS, AVG_BASKET_SIZE_WITH_VAT, AVG_BASKET_SIZE_NO_VAT→ default value on BE is SALES_WITH_VAT */
  sortBy?:
    | 'SALES_WITH_VAT'
    | 'ORDERS'
    | 'AVG_BASKET_SIZE_WITH_VAT'
    | 'AVG_BASKET_SIZE_NO_VAT'
    | 'AVG_BASKET_SIZE_ITEMS';
  /** Accepted values: DESC and ASC → default value on BE is DESC */
  sortOrder?: 'DESC' | 'ASC';
  locale: string;
  v2?: boolean;
}) => {
  const baseUrl = v2 ? getBaseUrlV2(entityType, entityId) : getBaseUrl(entityType, entityId);
  return merchantGatewayApi
    .get<PerformanceByVenueInsight>(`${baseUrl}/performance-by-venue`, {
      headers: { 'Accept-Language': locale },
      params: {
        ...getDateRangeForApiCall(interval),
        limit,
        cursor,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
    })
    .then(response => response.data);
};
